/**
 * Mirrors backend `App\Domain\Inventory\Enums\TransferStatus` (values must stay in sync).
 */
export const TRANSFER_STATUS = {
  DRAFT: 5,
  SENT: 10,
  RECEIVED: 15,
} as const

export type TransferStatusValue = (typeof TRANSFER_STATUS)[keyof typeof TRANSFER_STATUS]

export const TRANSFER_STATUS_OPTIONS: { value: TransferStatusValue; label: string }[] = [
  { value: TRANSFER_STATUS.DRAFT, label: 'Draft' },
  { value: TRANSFER_STATUS.SENT, label: 'Sent' },
  { value: TRANSFER_STATUS.RECEIVED, label: 'Received' },
]

/**
 * Resolves a human-readable label for a transfer status code.
 * @param status - Numeric status from the API (or null/undefined).
 * @returns Known label, or a stringified fallback / em dash when missing.
 */
export function getTransferStatusLabel(status: number | null | undefined): string {
  if (status == null) return '—'
  const found = TRANSFER_STATUS_OPTIONS.find((o) => o.value === status)
  return found?.label ?? String(status)
}
